var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95,36.48,79.45,8.87a3,3,0,0,0-2.62-1.53H23.16a3,3,0,0,0-2.61,1.53L5,36.48a3,3,0,0,0,.3,3.38l42.42,51.7a3.12,3.12,0,0,0,.45.44,1.88,1.88,0,0,0,.18.12,2.5,2.5,0,0,0,.35.21,1.63,1.63,0,0,0,.19.09l.21.08,0,0,.18,0,.14,0,.1,0a2.59,2.59,0,0,0,.48,0,2.81,2.81,0,0,0,.5,0l.06,0h0l.14,0L51,92.5l.15-.06,0,0,.15-.06.11-.06.15-.09.22-.15.08-.06,0,0,.07-.07a1.72,1.72,0,0,0,.27-.27l.08-.08,42.42-51.7A3,3,0,0,0,95,36.48ZM64.8,41H86.08L56,77.63C57.75,70.33,60.5,58.9,64.8,41Zm22.48-6H64.67L58.24,13.34H75.08ZM24.92,13.34H52L58.41,35H31.6a3,3,0,0,0,0,6h27C55.44,54.27,50.8,73.56,48.5,83.1L11.2,37.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAced);
export default __webpack_public_path__ + "static/media/Aced.ddc8ab4f1cb8e022eb381dbc21c117fd.svg";
export { ForwardRef as ReactComponent };